<template>
   <div class="grid-row" :style="gridStyles" v-if="grid">

       <div class="grid-column" v-for="(column, cIndex) in grid.columns" :key="'column-'+cIndex">

           <div class="grid-block" v-for="(block, bIndex) in column.blocks" :key="'block-'+bIndex">

                <template v-if="block.type == 'image'">
                   <component :is="block.link ? 'a' :'div'" :target="block.link ? '_blank' : null" :href="block.link || null" class="block-image" :style="{ '--grid-image-height': block.height+'px' }">
                       <img :src="block.image" />
                   </component>
                </template>
                <template v-else-if="block.type == 'text'">
                    <div class="prose" v-html="block.body"></div>
                </template>


           </div>


       </div>

       <template to="body">

            <vue-final-modal @closed="imageModal.closed" v-model="imageModal.visible">
                <div class="image-modal" v-if="imageModal.image">

                </div>
            </vue-final-modal>

       </template>

   </div>
</template>
<script setup>

    import { computed, onMounted, reactive, ref } from 'vue'

    const props = defineProps({
        grid: {
            default: false
        }
    })

    const gridStyles = computed(() => {
        return {
            '--grid-max-width': props.grid.maxWidth+'px',
            '--grid-template-columns': props.grid.span,
            '--grid-gap': props.grid.gap+'px',
            '--grid-margins': `${props.grid.margin.top} ${props.grid.margin.right} ${props.grid.margin.bottom} ${props.grid.margin.left}`
        }
    })

    const imageModal = reactive({
        image: null,
        visible: false,
        closed: () => true,
        opened: () => true
    })
    const imageModalClosed = () => {
        imageModal.image = null
        imageModal.visible = false
    }



</script>
<style lang="postcss">

    .grid-row{
        display: grid;
        gap: var(--grid-gap);
        @media screen and (min-width: 600px) {
            grid-template-columns: var(--grid-template-columns);
        }

        //margin: var(--grid-margins);
        margin: 0 auto;
        max-width: var(--grid-max-width);
        width: 100%;
        .grid-column {
            display: flex;
            gap: var(--grid-gap);
            width: 100%;
            flex-direction: column;
            .grid-block {


                .block-image {
                    overflow: hidden;
                    border-radius: 4px;
                    display: block;
                    img {
                        width: 100%;
                        display: block;
                        height: var(--grid-image-height);
                        object-fit: cover;
                    }
                }

            }
        }
    }

</style>
